import Breadcrumb from 'components/breadcrumb/breadcrumb'
import CoverImg from 'components/General/CoverImg'
import MainTitle from 'components/General/MainTitle'
import alger from '../../assets/img/alger.jpg'
import React, {useEffect, useState} from 'react'
import mission from "../../assets/img/alger3.jpg"
import { Container,Card,Row,Col } from 'react-bootstrap'
import { getMentionsLegales } from 'services/footer'
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser'
import { getAsset } from 'services/assets'

const MentionsLegales = ({ville}) => {
  const [data, setData] = React.useState();  
    useEffect(()=>{
        window.scrollTo({top:0})
        getMentionsLegales().then((x)=>{
            console.log(x)
            var z=x.items[0].data;
            console.log(z)
            setData(z)
          });
      },[])
      const [banner, setBanner] = useState();
useEffect( () => {
  if(data?.banner?.fr)
  getAsset(data?.banner?.fr).then((srcImage)=>{
    setBanner(srcImage);
  });
  
}, [data?.banner?.fr]);
      try{var text = parse(data?.Description?.fr)}catch($){
        text = data?.Description?.fr
      }
  return (
    <>
        <CoverImg img={banner}/>
        <Breadcrumb/>
        <Container>
            <MainTitle>{data?.Titre?.fr??("Mentions Legales")}</MainTitle>
            <div>
            <p>
{text}
            </p>
            </div>
        </Container>
    </>
  )
}

export default MentionsLegales